import React, { useState } from "react";

import ApiEndpoints from "../../network/ApiEndPoints";
import { postJsonData } from "../../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import { Box, Button, Grid, IconButton, Modal } from "@mui/material";
import { TextField } from "@material-ui/core";
import ModalFooter from "../../modals/ModalFooter";
import Loader from "../../component/loading-screen/Loader";
import { whiteColor } from "../../theme/setThemeColor";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Spinner from "../../component/loading-screen/Spinner";

const CreateUtils = ({ refresh }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ type: "", name: "" });
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      type: "",
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    postJsonData(
      ApiEndpoints.CREATE_UTILS,
      formData,
      setLoading,
      (res) => {
        okSuccessToast(res.data.message);
        refresh();
        setLoading(false);
        setOpen(false);
      },
      (error) => {
        apiErrorToast(error);
        setLoading(false);
      }
    );
  };

  return (
    <>
      {/* <Button
        onClick={() => setOpen(true)}
        appearance="primary"
        sx={{
          backgroundColor: "#1E90FF",
          color: "white",
          padding: "10px 20px",
          borderRadius: "5px",
          fontWeight: "bold",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#007BFF",
          },
        }}
      >
        + Add Utils
      </Button> */}
      <Button
        onClick={() => setOpen(true)}
        startIcon={
          <IconButton sx={{ p: 0, color: whiteColor() }}>
            <AddCircleOutlineIcon />
          </IconButton>
        }
        size="small"
        color="success"
        variant="contained"
        sx={{
          padding: 1,
          backgroundColor: "#2F3B57",
          borderRadius: "2px",
          color: whiteColor(),
        }}
      >
        Add Utils
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Spinner loading={loading} />
          <ModalHeader
            title="Add User"
            handleClose={handleClose}
            subtitle="Easily Add New User"
          />

          <form onSubmit={handleSubmit} id="add-util">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
              </Grid>
            </Grid>
          </form>

          <Box>
            <ModalFooter form="add-util" request={loading} btn="Add Util" />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CreateUtils;
